import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { WarningModal } from 'packages/eid-ui'
import { Button } from 'components'
import { useAddItemsToCart } from 'hooks'
import cartHelpers from 'containers/Cart/cartHelpers'

const DeleteAccessAssignment = ({ item, sharedFolder, refetch }) => {
    const { t } = useTranslation()

    const [showConfirm, setShowConfirm] = useState(false)
    const [addItemsToCart, { isLoading: isDeletingAssignment }] =
        useAddItemsToCart()

    const handleDelete = () => {
        const cartItem = cartHelpers.addRemoveAccessAssignmentToFolder({
            assignmentType: 'Remove',
            resource: sharedFolder,
            accessAssignment: item,
        })

        addItemsToCart([cartItem]).then(() => {
            refetch()
            setShowConfirm(false)
        })
    }

    return (
        <>
            <Button.Delete
                item={item}
                onClick={() => setShowConfirm(true)}
                disabled={item.isExpired}
            />

            <WarningModal
                title={t('Delete') + ' ' + item?.assigneeFriendlyName}
                description={t('SharedFolder_AssignmentDeleteMessage')}
                yesLabel={t('Delete')}
                noLabel={t('Cancel')}
                open={showConfirm}
                cancel={() => setShowConfirm(false)}
                proceeding={isDeletingAssignment}
                proceed={handleDelete}
            />
        </>
    )
}

DeleteAccessAssignment.defaultProps = {
    drawerView: false,
}
export default DeleteAccessAssignment
